// @flow
const includes = require('lodash/includes');

const supportedLanugaeCodes = ['en', 'es'];
const defaultLanguageCode = 'en';

function getDefaultLanguagePack() {
  return require(`./phrases_${defaultLanguageCode}.js`).default;
}

function getLanguagePack(languageCode: string): Object {
  const validLanguageCode = languageCode && includes(supportedLanugaeCodes, languageCode);
  const languagePhrases = validLanguageCode ?
    require(`./phrases_${languageCode}`).default :
    getDefaultLanguagePack();

  return languagePhrases;
}

module.exports = {
  defaultLanguageCode,
  getLanguagePack
};



// WEBPACK FOOTER //
// ./src/lang/index.js